import { createSelector } from 'reselect'
import moment from 'moment'

import { getOption } from './mappers'

export const getConfig = (state: RootState) => state.config

export const getControlId = createSelector(getConfig, config => config.controlId)

export const getMapVisualizer = (state: RootState) => state.mapVisualizer

export const getMapStructureOptions = createSelector(getMapVisualizer, mapVisualizer => mapVisualizer && mapVisualizer.map)

export const getMapDataRecords = createSelector(getMapVisualizer, mapVisualizer => mapVisualizer && mapVisualizer.data)

export const getMapInstanceSettings = createSelector(getMapVisualizer, mapVisualizer => mapVisualizer && mapVisualizer.instanceSettings)
export const getMapDisplaySettingsOptions = createSelector(
    getMapInstanceSettings,
    instanceSettings =>
        instanceSettings
        && { moduleTitle: instanceSettings.moduleTitle, moduleSubTitle: instanceSettings.moduleSubTitle, ...instanceSettings.layoutSettings })

export const getTitleOptions = createSelector(getMapInstanceSettings, instanceSettings => instanceSettings &&
    {
        titleText: instanceSettings.moduleTitle,
        titleStyle: {
            size: instanceSettings.layoutSettings.titleFontSize,
            color: instanceSettings.layoutSettings.titleColor,
            bold: instanceSettings.layoutSettings.titleBold,
            italic: instanceSettings.layoutSettings.titleItalic,
        },
        subTitleText: instanceSettings.moduleSubTitle,
        subTitleStyle: {
            size: instanceSettings.layoutSettings.subTitleFontSize,
            color: instanceSettings.layoutSettings.subTitleColor,
            bold: instanceSettings.layoutSettings.subTitleBold,
            italic: instanceSettings.layoutSettings.subTitleItalic,
        },
    })

export const getEChartsOptions = createSelector(
    [getMapStructureOptions, getMapDisplaySettingsOptions, getMapDataRecords],
    (options, displayOptions, dataRecords) => options && displayOptions && dataRecords && getOption(options, displayOptions, dataRecords))

export const getVisualMapDisplayEndDateTime = createSelector(getMapInstanceSettings, settings => settings && settings.displayEndDateTime && moment(settings.displayEndDateTime))

export const getVisualMapDisplayStartDateTime = createSelector(getMapInstanceSettings, settings => settings && moment(settings.displayStartDateTime))
